// @ts-check
import React from 'react';

import AuthenticatedLayout from '../layouts/AuthenticatedLayout';
import BusinessView from '@components/cards/businessview/overview/BusinessView';

/**
 * Business View reporting page. Wraps the Business View component in the
 * authenticated app shell (navbar + sidebar + footer).
 *
 * @returns {JSX.Element}
 */
export default function BusinessViewPage() {
  return (
    <AuthenticatedLayout>
      <BusinessView />
    </AuthenticatedLayout>
  );
}